export default {
    "scales": {
        "scale": {
            "showName": "Шкала",
            "templatesFolder": "componentsCompany/level/elementScales/scale"
        }
    }
}